import { routerReducer as routing } from "react-router-redux"

export default {
  routing
}

export const getLocale = (state) => state.utils.locale
